import React, { useState, useEffect, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Trustee.css";
import URLstateContext from "../../../provider/CommonContext";
import { Modal } from "react-bootstrap";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import { AiFillCloseCircle } from "react-icons/ai";
import { Vortex } from "react-loader-spinner";
import animation from "../../../images/jm-animation.gif";
import { trackEvent, trackPageView } from "../../utils/tracking";

function Trustee() {
  const [data, setData] = useState([]);
  const [Fetchdata, getData] = useState("");
  const { BaseURL } = useContext(URLstateContext);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [filteredNewsData, setFilteredNewsData] = useState([]);
  const [loadingshow, setloadingshow] = useState(false);

  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/AboutUs/Trustee-Board",
      "jmf_about-us_trustee-board"
    );
    // trackPageView("http://localhost:710/AboutUs", "jmf_about-us");

    trackEvent({
      category: "Dynamic Page",
      action: "Trustee Page Loaded",
      label: "jmf_about-us_trustee-board",
      // value: 1,
    });
  }, []);

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetAboutUs", {
      teamid: 2,
      INprofile: 0,
      designation: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
  }, [BaseURL]);

  const handleClosePopup = () => {
    setShow(false);
  };
  const newsModal = (e) => {
    const fetchId = e.currentTarget.getAttribute("data-id");
    //alert(fetchId)
    let filteredCompanyInformation = data.filter((oneData) => {
      return parseInt(oneData["srno"]) === parseInt(fetchId);
    });
    setFilteredNewsData(filteredCompanyInformation);
    handleShow();
  };

  return (
    <>
      <section className="trustee-sc">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="section-header">
                <h2>Trustee Board</h2>
                <h3>JM Financial Trustee Company Private Limited</h3>
              </div>
            </Col>
            <Col sm={12}>
              <div className="about-common-left">
                <h3>Registered Office:</h3>
                <p>141, Maker Chambers III, Nariman Point, Mumbai - 400 021.</p>
              </div>
              <div className="about-common-right">
                <p>
                  JM Financial Trustee Company Private Limited (formerly known as J.M. Trustee Company Private Limited) has been promoted by J.M. Financial & Investment Consultancy Services Pvt. Ltd., SNK Investments Pvt. Ltd. and Mr. Nimesh N. Kampani. JM Financial Trustee Company Pvt. Ltd. is registered under the Companies Act, 1956 and was incorporated on 9th June 1994. The Sponsors have executed a Trust Deed on 1st September 1994 appointing JM Financial Trustee Company Pvt. Ltd. as Trustee Company of JM Financial Mutual Fund. 
                </p>
              </div>
            </Col>
            <Col sm={12}>
              <h4 className="trusteef">
                Details of Trustees Board-Accomplished individuals, Diverse
                experience
              </h4>
              <div className="member-main">
                {/* <h5 className="trusteef">
                  The Board of Trustees comprises of eminent personalities with
                  varied experience, details are as given below:
                </h5> */}
                {data === null ? (
                  <h5 className="errormsgComNew" role="alert">No Data Available !!!</h5>
                ) : (
                  ""
                )}
                {data &&
                  data.map(({ name, desgination, filename, srno, image }) => (
                    <div className="board-pnl">
                      <button
                       type="button"
                    className="board-member-btn"
                    data-id={srno}
                    onClick={newsModal}
                    aria-label={`View details for ${name}`}
                      >
                      <div className="">
                        <img
                          // src={BaseURL.replace("api/", "") + image}
                          src={image}
                          data-id={srno}
                          onClick={newsModal}
                          alt={name}
                          className="img-fluidd img-about"
                        />
                        <h4 className="name">{name}</h4>
                        <p>{desgination}</p>
                      </div>

                      </button>
                    </div>
                  ))}
              </div>
            </Col>
            {filteredNewsData === null ? (
              <h5 className="errormsgComNew" role="alert">No Data Available !!!</h5>
            ) : (
              ""
            )}
            {filteredNewsData &&
              filteredNewsData.map(
                ({ name, description, desgination, image }) => (
                  <Modal show={show} className="modal modal-teams">
                    <Modal.Body id="modal_info">
                      <div className="btnDiv">
                        <div className="" onClick={handleClosePopup}>
                          <AiFillCloseCircle className="btncl" />
                        </div>
                      </div>
                      <div className="modal-info">
                        <div className=" img-about-modal">
                          <img
                            // src={BaseURL.replace("api/", "") + image}
                            src={image}
                            alt={name}
                            className="img-fluidd"
                          />
                          <div className="titleCompany">
                            <h5>{desgination}</h5>
                            <hr className="hrtrust"></hr>
                          </div>
                        </div>
                        <div className="infoCompanyy">
                          <h4>{name}</h4>
                          <hr className="hrtrust"></hr>
                          <p className="popupAmc">{description}</p>
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal>
                )
              )}
            {loadingshow ? (
              <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                <img src={animation} alt="" aria-hidden="true"/>
                <div className="model_popup">Please Wait...</div>
              </div>
            ) : (
              ""
            )}
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Trustee;
